import * as actions from '../consts';

export const openConfirmModal = (submitFunc, header, description) => ({
  type: actions.OPEN_CONFIRM_MODAL,
  data: { submitFunc, header, description }
});

export const closeConfirmModal = () => ({
  type: actions.CLOSE_CONFIRM_MODAL
});